import {
  Box,
  Grid,
  Typography,
  SxProps,
  Theme
} from "@mui/material";
import { CommonStyles } from "../styles/CommonStyles";
import ReinovaButton from "../components/ReinovaButton";
import PageTitle from "../components/PageTitle";
import PageContent from "../components/PageContent";
import { useIsMobile } from "../hooks/useIsMobile";
import { useTranslation } from "react-i18next";


const WhistleblowingPageStyle: Record<string, SxProps<Theme>> = {
  captionTitle: {
    fontSize: "27px",
    textAlign: "left",
    marginBottom: "20px",
    fontWeight: "bold",
  },
  captionTitleMobile: {
    fontSize: "20px",
    textAlign: "center",
  },
  captionTextMobile: {
    fontSize: "18px",
    textAlign: "center",
    background: "#37314A",
    padding: "20px",
    borderRadius: "10px",
    marginTop: "20px",
  },
  captionText: {
    fontSize: "22px",
    textAlign: "left",
  },
  headerImage: {
    maxHeight: "200px",
    img: {
      height: "200px",
      width: "100%",
      objectFit: "cover",
    },
  },
};


export default function WhistleblowingPage() {
    const { isMobile } = useIsMobile();
    const { t } = useTranslation();

    return (<>
        <PageTitle>{t("menu.whistle")}</PageTitle>
        <PageContent>
            <Grid container spacing={4} sx={{ alignItems: "center" }}>
                <Grid item md={12}>
                    <Box
                        sx={[
                            isMobile
                                ? CommonStyles.borderedImageMobile
                                : CommonStyles.borderedImage,
                            WhistleblowingPageStyle.headerImage,
                        ].flat(2)}
                    >
                        {/* <img src={isMobile ? careersHeaderMobileImg : careersHeaderImg} alt="insegna reinova" /> */}
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} spacing={3}>
                    <Typography
                        sx={ isMobile ? WhistleblowingPageStyle.captionTitleMobile : WhistleblowingPageStyle.captionTitle } >
                        {t("whistle.1")}
                    </Typography>
                    <Typography
                        sx={ isMobile ? WhistleblowingPageStyle.captionTextMobile : WhistleblowingPageStyle.captionText } >
                        {t("whistle.2")}
                    </Typography>
                    <Typography
                        sx={ isMobile ? WhistleblowingPageStyle.captionTextMobile : WhistleblowingPageStyle.captionText } >
                        {t("whistle.3")}
                    </Typography>
                    <Typography sx={ isMobile ? WhistleblowingPageStyle.captionTextMobile : WhistleblowingPageStyle.captionText } >
                        {t("whistle.4")}
                    </Typography>
                    <Typography sx={ isMobile ? WhistleblowingPageStyle.captionTextMobile : WhistleblowingPageStyle.captionText } >
                        {t("whistle.5")}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                    {/* <Card
                        sx={
                            isMobile
                                ? [CommonStyles.cardContainerMobile, {width: "100%"}].flat(2)
                                : CommonStyles.cardContainer
                        }
                    >
                        <CardContent>
                            <Typography
                                sx={[
                                    isMobile
                                        ? CommonStyles.cardTitleMobile
                                        : CommonStyles.cardTitle,
                                    { textAlign: "center" },
                                ].flat(2)}
                            >
                                {t("whistle.6")}
                            </Typography>
                        </CardContent>
                        <CardActions
                            sx={{ alignItems: "center", justifyContent: "center" }}
                        > */}
                            <ReinovaButton onClick={() => window.open("https://whistleblowersoftware.com/secure/reinova-ext")}>
                                {t("whistle.6")}
                            </ReinovaButton>
                        {/* </CardActions>
                    </Card> */}
                </Grid>
            </Grid>
        </PageContent>
    </>
    );
};